import { HeroSection, HeroContent, HeroTitle, HeroSubtitle } from './styles';
import { Button } from '../Button';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <HeroSection>
      <HeroContent>
        <HeroTitle>Ensemble pour un monde plus juste</HeroTitle>
        <HeroSubtitle>
          Lutte contre la pauvreté et l'injustice sociale par la promotion des droits de l'homme
          avec la participation populaire
        </HeroSubtitle>
        <div>
          <Link to="/programs">
            <Button $primary>Découvrir nos programmes</Button>
          </Link>
          <Link to="/contact">
            <Button style={{ marginLeft: '1rem' }}>Nous rejoindre</Button>
          </Link>
        </div>
      </HeroContent>
    </HeroSection>
  );
};

export default Hero;